module.exports = __webpack_public_path__ + "static/media/cv.10bc0622.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cv.svg
// module id = 842
// module chunks = 0